export var DataHubSystems;
(function (DataHubSystems) {
    DataHubSystems["HotmartClub"] = "hotmart_club";
})(DataHubSystems || (DataHubSystems = {}));
